<lib-form-container [smallMode]="true">
    <h1>Accès refusé</h1>

    <p>Vous n'avez pas les droits pour accéder à cette page</p>
</lib-form-container>
